import React from 'react'; 
import axios from 'axios'; 


class AdminForms extends React.Component {
    constructor(props){
        super(props); 

        this.state = {
            forms: [],
        }
    }

    componentDidMount() {
        if (this.props.userdata.isLoggedIn){
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }
            
            axios.get(this.props.apiurl + '/api/getAllForms', {headers: headers}).then(res => {
                this.setState({
                    forms: res.data.forms
                })
            }).catch(err => {
                console.log(err); 
            }); 
        }
    }

    handleCopyToClipboard = (text) => {
        let link = this.props.apiurl + '/form/' + text; 
        navigator.clipboard.writeText(link)
    }

    render(){
        let forms = []; 

        this.state.forms.map((form, index) => {
            forms.push(
                <tr key={index}>
                    <th scope="row">
                        <button className="btn btn-sm btn-outline-primary" onClick={ () => this.handleCopyToClipboard(form.formCode)}>{ form.formCode }</button> 
                    </th>
                    <td>{ form.name }</td>
                    <td>{ form.user.username }</td>
                    <td>
                        <button className="btn btn-sm btn-outline-secondary mx-1" onClick={ () => this.handleEditForm(form.formCode, this.props.userdata.userId)}>Edit</button>
                        <button className="btn btn-sm btn-outline-secondary mx-1" onClick={ () => window.open(this.props.apiurl + "/form/" + form.formCode, "_blank") }>Preview</button>
                        <button className="btn btn-sm btn-outline-danger mx-1" onClick={ () => this.handleDeleteForm(form.formCode, this.props.userdata.userId)}>Delete</button>
                        
                    </td>
                </tr>
            )
        }); 

        return(
            <div className="container">
                <div className="row mb-2">
                    <div className="col">
                        <h4>Forms</h4>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Form Code <small>Copy to Clipboard</small></th>
                                    <th scope="col">Name</th>
                                    <th scope="col">User</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {forms}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminForms; 

